import EmployeeSalaryAccumulateComponents from "../components/EmployeeSalaryAccumulate";
import useEmployeeSalaryAccumulate from "../hooks/useEmployeeSalaryAccumulate";

function EmployeeSalaryAccumulate() {
  const employeeSalaryAccumulateProps = useEmployeeSalaryAccumulate();
  return (
    <EmployeeSalaryAccumulateComponents {...employeeSalaryAccumulateProps} />
  );
}

export default EmployeeSalaryAccumulate;
